let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8sry2")).then(() => parcelRequire('h0vOS'));